var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"blade2"}},[_c('blade2a'),_c('blade2b')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }